import { render, staticRenderFns } from "./Visualizar-Fornecedor.vue?vue&type=template&id=7a167c94&scoped=true&"
import script from "./Visualizar-Fornecedor.vue?vue&type=script&lang=js&"
export * from "./Visualizar-Fornecedor.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar-Fornecedor.vue?vue&type=style&index=0&id=7a167c94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a167c94",
  null
  
)

export default component.exports